import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import moment from 'moment';

import getIngresos from '../../../graphql/querys/ventas/getIngresos.graphql';
import getIngresosPorRangoConFiltros from '../../../graphql/querys/ventas/getIngresosPorRangoConFiltros.graphql';
import getCantidadIngresosConFiltros from '../../../graphql/querys/ventas/getCantidadIngresosConFiltros.graphql';

import aprobarEnvio from '../../../graphql/mutations/venta/aprobarEnvio.graphql';
import desaprobarEnvio from '../../../graphql/mutations/venta/desaprobarEnvio.graphql';
import deleteIngreso from '../../../graphql/mutations/venta/deleteIngreso.graphql';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actionsPedido from '../../../actions/pedido';
import * as actionsMain from '../../../actions/main';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import TablaIngresos from './TablaIngresos';

import ModalVerPedido from './ModalVerPedido';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
const confirm = Modal.confirm;

@compose(
  graphql(getUsuario),
  graphql(getOrganismos, { name: 'organismos' }),
  graphql(deleteIngreso, {
    name: 'deleteIngreso',
    options: {
      refetchQueries: [{ query: getIngresos }],
    },
  })
)
class VerIngresos extends React.Component {
  constructor(props) {
    super(props);

    let fechaIni = moment()
      .subtract(7, 'd')
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toDate();

    let fechaFin = moment()
      .endOf('day')
      .toDate();

    this.state = {
      loading: false,
      filtro: props.usuario.organismo ? props.usuario.organismo._id : '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      listaOriginal: [],
      fechaInicial: fechaIni,
      fechaFinal: fechaFin,
      pedido: {},
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
    };
    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id_ingreso) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este envio?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteIngreso({
            variables: { _id: id_ingreso },
          })
          .then(res => {
            let id = res.data.deleteIngreso;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);
              notification.warning({
                message: 'Envio eliminado',
                description: 'Se ha eliminado el envio exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el envio');
            console.log(err);

            Modal.error({
              title: 'Error en la eliminacion del envio',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  cambiarOrganismo = idOrganismo => {
    this.setState(
      {
        ...this.state,
        idOrganismo: idOrganismo,
        filtro: idOrganismo,
      },
      () => this.buscarEnvios()
    );
  };

  obtenerNombreOrganismo = idOrganismo => {
    let nombre = '';
    let organismo = _.find(this.props.data.getOrganismos, { _id: idOrganismo });
    organismo ? (nombre = organismo.nombre) : (nombre = '');
    return nombre;
  };

  buscarEnvios = () => {
    // this.setState({ loading: true });
    this.props.client
      .query({
        query: getCantidadIngresosConFiltros,
        variables: {
          fechaInicial: this.state.fechaInicial,
          fechaFinal: this.state.fechaFinal,
          filtroOrganismo: this.state.filtro,
        },
        fetchPolicy: 'network-only',
      })
      .then(resp => {
        if (
          resp.data.getCantidadIngresosConFiltros ||
          resp.data.getCantidadIngresosConFiltros == 0
        ) {
          this.setState({
            cantidadTotal: resp.data.getCantidadIngresosConFiltros,
          });

          this.props.client
            .query({
              query: getIngresosPorRangoConFiltros,
              variables: {
                fechaInicial: this.state.fechaInicial,
                fechaFinal: this.state.fechaFinal,
                filtroOrganismo: this.state.filtro,
                pagina: this.state.pagina,
                cantidadPorPagina: this.state.cantidadPorPagina,
              },
              fetchPolicy: 'network-only',
            })
            .then(res => {
              this.setState(
                {
                  ...this.state,
                  listaTotal: res.data.getIngresosPorRangoConFiltros,
                  listaOriginal: res.data.getIngresosPorRangoConFiltros,
                  primeraCarga: false,
                  loading: false,
                },
                function() {
                  this.ordenarLista(
                    this.state.pagina,
                    this.state.cantidadPorPagina
                  );
                }
              );
            })
            .catch(err => {
              console.log('ERROR EN EL INGRESOS POR RANGO: ');
              console.log(err);

              Modal.error({
                title: 'Error en la busqueda de ingresos por rango',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE OBTENER LA CANTIDAD TOTAL DE INGRESOS');
        console.log('EL ERROR ES: ', err);
      });
  };

  componentDidMount() {
    this.buscarEnvios();
  }

  // eslint-disable-next-line no-unused-vars
  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        ingreso => {
          return ingreso.fechaEnvio;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaOrdenada,
    });
  };

  // eslint-disable-next-line no-unused-vars
  onChangeFechas = (date, dateString) => {
    this.setState(
      {
        ...this.state,
        fechaInicial: date[0]
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate(),
        fechaFinal: date[1]
          .set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
          .toDate(),
        pagina: 1,
      },
      () => {
        this.buscarEnvios();
      }
    );
  };

  borrarFiltros = () => {
    this.setState(
      {
        ...this.state,
        filtro: '',
        fechaInicial: null,
        fechaFinal: null,
        lista: this.props.data.getIngresos,
        listaTotal: this.props.data.getIngresos,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  aprobarEnvio = _id => {
    this.props.client
      .mutate({
        mutation: aprobarEnvio,
        variables: { _id },
      })
      .then(res => {
        // console.log("La respuesta fue....");
        // console.log(res);

        if (res.data.aprobarEnvio._id) {
          notification.warning({
            message: 'Envio aprobado',
            description: 'Se ha aprobado correctamente el envio',
          });
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de aprobar el envio');
        console.log(err);

        Modal.error({
          title: 'Error en la aprobacion del envio, (Comprobar STOCK)',
          content:
            'La operacion que intento llevar a cabo no se realizo correctamente, compruebe de que exista el stock para la aprobacion de este envio.',
        });
      });
  };

  desaprobarEnvio = _id => {
    this.props.client
      .mutate({
        mutation: desaprobarEnvio,
        variables: { _id },
        refetchQueries: [{ query: getIngresos }],
      })
      .then(res => {
        if (res.data.desaprobarEnvio) {
          notification.warning({
            message: 'Envio desaprobado',
            description: 'Se ha desaprobado correctamente el envio',
          });
        }
      })
      .catch(err => {
        console.log('Existio un error a la hora de desaprobar el envio');
        console.log(err);

        Modal.error({
          title: 'Error en el sistema, intentelo nuevamente',
          content:
            'La operacion que intentó realizar fallo, por favor, intentelo nuevamente. Si el error persiste, comunicarse con mesa de ayuda',
        });
      });
  };

  mostrarModalVerPedido = record => {
    // console.log('entre...');
    this.setState(
      {
        pedido: record.pedido,
      },
      () => {
        this.props.actionsMain.setVerPedidoEnvio(
          !this.props.main.verPedidoEnvio
        );
      }
    );
  };

  ocultarModalPedido = () => {
    // console.log('entre. 2..');
    this.setState(
      {
        pedido: {},
      },
      () => {
        this.props.actionsMain.setVerPedidoEnvio(
          !this.props.main.verPedidoEnvio
        );
      }
    );
  };

  cambiarPagina = pagina => {
    this.setState(
      {
        pagina: pagina,
      },
      () => {
        this.buscarEnvios();
      }
    );
  };

  cambiarTamañoPagina = tamaño => {
    this.setState({
      cantidadPorPagina: tamaño,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    const { usuario } = this.props;

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaIngresos
          envios={this.state.lista}
          pagination={pagination}
          onChange={this.onChangeFechas}
          onDelete={this.onDelete}
          organismos={this.props.organismos.getOrganismos}
          usuario={usuario}
          cambiarOrganismo={this.cambiarOrganismo}
          filtroOrganismo={this.state.filtro}
          mostrarModalVerPedido={this.mostrarModalVerPedido}
          aprobarEnvio={this.aprobarEnvio}
          desaprobarEnvio={this.desaprobarEnvio}
          history={this.props.history}
          fechaInicial={this.state.fechaInicial}
          fechaFinal={this.state.fechaFinal}
          pagina={this.state.pagina}
          cambiarPagina={this.cambiarPagina}
          cambiarTamañoPagina={this.cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          cantidadPorPagina={this.state.cantidadPorPagina}
        />
        {this.props.main.verPedidoEnvio && (
          <ModalVerPedido
            mostrarModalVerPedido={this.props.main.verPedidoEnvio}
            ocultarModalPedido={this.ocultarModalPedido}
            pedido={this.state.pedido}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actionsPedido: bindActionCreators(actionsPedido, dispatch),
  actionsMain: bindActionCreators(actionsMain, dispatch),
});

function mapStateToProps(state) {
  // console.log('mapStateToPorps: ', state);
  return state;
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withApollo(VerIngresos));
